import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { parseLastContactDate } from './lastContact';
import { getOverdueByLabel } from '../sections/@dashboard/leadDetail/AttendedGuidedChecklist/v2/UpNextCardV2';

dayjs.extend(utc);
dayjs.extend(timezone);

const LONDON_TIME_ZONE = 'Europe/London';

// describeNextTask(nextTaskDueAt, now)
//
// Pure classifier for the New-lead table's "Next Task" cell. Reuses the
// canonical Europe/London parser from lastContact.js so the two date-ish
// columns on this table agree on timezone handling (BST/GMT, DRF's legacy
// "DD-MM-YYYY HH:mm:ss.SSSSSSZ" shape, and plain ISO).
//
// Overdue/today/upcoming TONE is judged on CALENDAR DAY boundaries in
// Europe/London — a task due at 23:30 London yesterday is overdue the moment
// the London clock ticks past midnight, even if fewer than 24 raw hours have
// elapsed.
//
// The "Overdue by N days/hours" NUMBER, once overdue, reuses
// UpNextCardV2's getOverdueByLabel — the exact same rolling 24h-floor rule
// the follow-up popup's "Up next" card uses — so the cell and the card never
// disagree (2026-10-02: cell said "Overdue by 141 days", card said "140
// days" for the same task, because the cell's own calendar-day diff and the
// card's rolling-hours diff can differ by up to a day depending on time of
// day).
export const describeNextTask = (nextTaskDueAt, now = new Date()) => {
    const due = parseLastContactDate(nextTaskDueAt);
    if (!due) {
        return { tone: 'none', label: '' };
    }

    const nowLondon = dayjs(now).tz(LONDON_TIME_ZONE);
    const dueStartOfDay = due.startOf('day');
    const nowStartOfDay = nowLondon.startOf('day');
    const calendarDaysOverdue = nowStartOfDay.diff(dueStartOfDay, 'day');

    if (calendarDaysOverdue > 0) {
        return {
            tone: 'overdue',
            label: `Overdue by ${getOverdueByLabel(due.toDate(), now)}`,
        };
    }

    if (calendarDaysOverdue === 0) {
        return {
            tone: 'today',
            label: `Due today ${due.format('HH:mm')}`,
        };
    }

    return {
        tone: 'upcoming',
        label: `Due ${due.format('DD MMM HH:mm')}`,
    };
};

// formatNextTaskTooltip(dueAt) -> "Due ddd DD MMM YYYY, HH:mm" in Europe/London,
// or '' when there is no due date. Used for the Next Task cell's tooltip
// (exact datetime) alongside the relative describeNextTask() pill label.
export const formatNextTaskTooltip = (nextTaskDueAt) => {
    const due = parseLastContactDate(nextTaskDueAt);
    if (!due) return '';
    return `Due ${due.format('ddd DD MMM YYYY, HH:mm')}`;
};

export default describeNextTask;
